module.exports = __webpack_public_path__ + "sipgate_bw.svg?0e6fb2c189cf2b8b1e1fc929cab4ba5f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patterns/sipgate_bw.svg
// module id = 19
// module chunks = 0